import { useCallback, useEffect, useState } from 'react';

const TTL_KEY = 'loginCountWithTTL';

function setLoginCountWithTTL(count: number, ttlInSeconds: number) {
  const now = Date.now();
  const item = {
    count,
    expiresAt: now + ttlInSeconds * 1000,
  };
  localStorage.setItem(TTL_KEY, JSON.stringify(item));
}

function getLoginCountWithTTL(): number {
  const itemStr = localStorage.getItem(TTL_KEY);
  if (!itemStr) return 0;

  try {
    const item = JSON.parse(itemStr);
    if (Date.now() > item.expiresAt) {
      localStorage.removeItem(TTL_KEY);
      return 0;
    }
    return item.count;
  } catch {
    localStorage.removeItem(TTL_KEY);
    return 0;
  }
}

export function useLoginCountWithTTL(defaultTTL = 600) {
  const [loginCount, setLoginCount] = useState<number>(() => getLoginCountWithTTL());

  const login = useCallback(() => {
    const currentCount = getLoginCountWithTTL();
    const newCount = currentCount + 1;
    setLoginCountWithTTL(newCount, defaultTTL);
    setLoginCount(newCount);
  }, [defaultTTL]);

  const reset = useCallback(() => {
    localStorage.removeItem(TTL_KEY);
    setLoginCount(0);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const count = getLoginCountWithTTL();
      setLoginCount(count);
    }, 1000); // update every second to check TTL

    return () => clearInterval(interval);
  }, []);

  return { loginCount, login, reset };
}
